import TokenStore from "../stores/TokenStore";
import CurrentOrganizationIdStore from "../stores/CurrentOrganizationIdStore";
import AppDispatcher from "../AppDispatcher";
import Constants from "../Constants";
import ContentAPI from "../util/ContentAPI";

const ContentActions = {
  loadContent() {
    const orgId = CurrentOrganizationIdStore.getState();
    new ContentAPI(TokenStore.getToken()).content.get(orgId).then((content) => {
      AppDispatcher.dispatch({
        actionType: Constants.Content.CONTENT_RECEIVED,
        content,
      });
    });
  },
  loadPage(pageId) {
    const orgId = CurrentOrganizationIdStore.getState();
    new ContentAPI(TokenStore.getToken()).content
      .getPage(orgId, pageId)
      .then((content) => {
        AppDispatcher.dispatch({
          actionType: Constants.Content.CONTENT_RECEIVED,
          content,
        });
      });
  },
  loadIndex() {
    const orgId = CurrentOrganizationIdStore.getState();
    new ContentAPI(TokenStore.getToken()).content
      .getIndex(orgId)
      .then((index) => {
        AppDispatcher.dispatch({
          actionType: Constants.Content.INDEX_RECEIVED,
          index,
        });
      });
  },
  loadProjects() {
    const orgId = CurrentOrganizationIdStore.getState();
    new ContentAPI(TokenStore.getToken()).content
      .getProjects(orgId)
      .then((content) => {
        AppDispatcher.dispatch({
          actionType: Constants.Content.CONTENT_RECEIVED,
          content,
          projects: true,
        });
      });
  },
  loadProjectPages(projectId) {
    const orgId = CurrentOrganizationIdStore.getState();
    new ContentAPI(TokenStore.getToken()).content
      .getProjectPages(orgId, projectId)
      .then((content) => {
        AppDispatcher.dispatch({
          actionType: Constants.Content.CONTENT_RECEIVED,
          content,
        });
      });
  },
};

export default ContentActions;
